<template>
  <div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Buscar Cliente</span>
    </a>

    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
    <div class="modal-dialog modal-xl" role="document" style="max-width: 100%;">
        <div class="modal-content modal-xl" style="max-width: 100%;">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cuentas de Clientes</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                Buscar por: {{ tipo_busqueda }}
              </div>
              <div class="col-12" style="color: red;" v-if="mensajeErrorCF">
                <i class="fas fa-info-circle"></i>
                {{ mensajeErrorCF }}
              </div>
              <div class="col-12 pt-1">
                <div class="toggle-switch-wrapper">
                  <input type="checkbox" v-model="tipoBusqueda" id="toggleSwitch" class="toggle-switch-input">
                  <label for="toggleSwitch" class="toggle-switch-label">
                      <span class="toggle-switch-text-off">Cliente</span>
                      <span class="toggle-switch-slider"></span>
                      <span class="toggle-switch-text-on">Súper Cliente</span>
                  </label>
                </div>
              </div>
              <div class="col-12" v-if="tipoBusqueda">
                <SuperClienteClienteSelectComponent
                  @super-selected="handleSuperSelectedData"
                ></SuperClienteClienteSelectComponent>
                <!--<SuperClientesSelectComponent :current="currentSuperCliente"></SuperClientesSelectComponent>-->
              </div>
              <div class="col-12" v-else>
                <ClientesSelectComponent :current="current" />
              </div>
              <div class="col-12">
                <CuentasTableComponent
                  @setDefault="setDefault"
                  :datos="_current"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="current.cliente_nit || current.super_cliente"
              class="btn"
              @click="agregarCobro(current)"
              style="background-color: #ff8d33"
              onmouseover="this.style.color='black'"
              onmouseout="this.style.color='white'"
            >
              agregar un nuevo Cobro
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddCobro"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cuentas de Clientes</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h6 class="modal-title text-danger">
              Complete la siguiente información
            </h6>
            <br />
            <div class="row">
              <div class="col-12">
                <ClientesSelectComponent :current="current" />
              </div>
              <div class="col-12">
                <TiendaSelectComponent
                  @change="refreshCaja(current)"
                  :current="current"
                />
              </div>
              <div v-if="current.tienda" class="col-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.caja,
                    }"
                    >Caja</label
                  >
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="current.caja"
                  >
                    <option v-for="(c, key) in caja" :value="c.id" :key="key">
                      Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                    </option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.caja"
                    class="form-text text-danger"
                    >{{ current.errors.caja }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="current.cliente_nit"
              class="btn"
              @click="guardar(current)"
              style="background-color: #ff8d33"
              onmouseover="this.style.color='black'"
              onmouseout="this.style.color='white'"
            >
              Guardar Información
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import SuperClientesSelectComponent from "@/components/commons/SuperClientesSelectComponent";
import SuperClienteClienteSelectComponent from "@/components/commons/SuperClienteClienteSelectComponent";
import CuentasTableComponent from "@/components/cxc/cobros/CuentasTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    SuperClientesSelectComponent,
    CuentasTableComponent,
    TiendaSelectComponent,
    SuperClienteClienteSelectComponent,
  },
  watch: {
    // La clave del watcher es la ruta de la propiedad que quieres observar
    currentSuperCliente: {
      handler(nuevoValor, valorAnterior) {
        if (nuevoValor == null) {
          this.current.cliente_nit = null;
        }else{
          this.current.cliente_nit = this.cliente
        }
      },
      immediate: true
    }
  },
  computed:{
    mensajeErrorCF(){
      return this.tipoBusqueda && (this.current.cliente_nit && this.cliente.nit === "CF") ? "Es recomendado que el cliente lleve nit para su debido cobro, favor tomarlo en cuenta para futuros cobros." : null;
    },
    tipo_busqueda(){
      this.current.cliente_nit = null;
      if(!this.tipoBusqueda){
        if(this.current.super_cliente){this.current.super_cliente = null;}
        return "Cliente";
      }
      return "Súper Cliente";
    },
    cliente(){
      let data = {
        nit: this.tipoBusqueda ? this.currentSuperCliente.nit : this.current.cliente_nit.nit,
        nombre: this.tipoBusqueda ? this.currentSuperCliente.nombre : this.current.cliente_nit.nombre,
        direccion: this.tipoBusqueda ? this.currentSuperCliente.direccion : this.current.cliente_nit.direccion,
        email: this.tipoBusqueda ? this.currentSuperCliente.email : this.current.cliente_nit.email,
        super_cliente: this.tipoBusqueda ? this.currentSuperCliente.super_cliente : null,
      };
      return data;
    },
    _current(){
      this.current.cliente_nit = this.current.cliente_nit ? this.cliente : null
      return this.current;
    }
  },
  data() {
    return {
      tipoBusqueda:false,
      caja: "",
      current: {
        cliente_nit: null,
        cliente_nombre: "",
        cliente_direccion: "",
        tienda: null,
        caja: null,
        estado: "A",
        super_cliente: null,
        errors: [],
      },
      currentSuperCliente: null,
    };
  },
  mounted() {},
  methods: {
    // Este método se ejecutará cuando el componente hijo emita 'super-selected'
    handleSuperSelectedData(data) {
      this.currentSuperCliente = data;
    },
    guardar(id) {
      let self = this;
      (self.params = {
        cliente_nit: self.cliente.nit,
        cliente_nombre: self.cliente.nombre,
        cliente_direccion: self.cliente.direccion,
        email: self.cliente.email,
        cliente: self.cliente.nit,
        tienda: self.current.tienda,
        caja: self.current.caja,
        super_cliente: self.cliente.super_cliente,
      }),
      console.log(self.params);
        DynamicService.save("cxc", "cobros", self.params)
          .then((response) => {
            $("#modalAddCobro").modal("hide");
            this.$emit("refresh");
            Notifications.alert.success(
              "Agregar Nuevo Cobro",
              "Se ha realizado correctamente"
            );
            id = response.data.id;
            self.$router.push({
              name: "cxc-cobros-editar",
              params: { id },
            });
          })
          .catch((error) => {
            /*
            Así se maneja los errores cuando se desconoce qué error ocurrió.
            */
            self.current.errors = error.response.data; // Se guarda el listado de errores
            const errors = Object.keys(error.response.data); // Se extraen las llaves o nombres de error
            // Se maneja uno por uno en caso exista más de uno y se muestra el error de la forma que más desee el desarrollador
            errors.forEach((error) => {
              self.$toast.warning(JSON.stringify(`${error}: ${self.current.errors[error]}`),"Aviso",{position: 'topRight'});
            });
          });
    },
    refreshCaja(current) {
      let self = this;
      DynamicService.fetch("cxc", "caja", {
        tienda: current.tienda,
      }).then((response) => {
        self.caja = response.data.results;
      });
    },
    agregarCobro(current) {
      let self = this;
      this.current.cliente_nit = this.cliente
      console.log(this.cliente);
      $("#modalAddProductoPrecio").modal("hide");
      $("#modalAddCobro").modal();
    },
    setDefault() {
      let self = this;
      self.current.cliente_nit = "";
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      CajaService.fetch({
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },
  },
};
</script>
<style scoped>
/* Contenedor principal del switch */
.toggle-switch-wrapper {
    display: flex;
    align-items: center;
    gap: 15px; /* Espacio entre el switch y los textos si estuvieran fuera del label */
}

/* Oculta el checkbox nativo */
.toggle-switch-input {
    display: none;
}

/* Estilo del label que actuará como el switch visual */
.toggle-switch-label {
    display: flex;
    align-items: center;
    position: relative;
    width: 180px; /* Ancho total del switch */
    height: 40px; /* Altura del switch */
    background-color: #e0e0e0; /* Color de fondo cuando está apagado */
    border-radius: 25px; /* Bordes redondeados para el carril */
    cursor: pointer;
    transition: background-color 0.3s ease; /* Transición suave del fondo */
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1), 0 1px 0 rgba(255,255,255,0.7); /* Sutil sombra interna */
}

/* Estilo del "slider" o "botón" del switch */
.toggle-switch-slider {
    position: absolute;
    width: 75px; /* Ancho del botón */
    height: 34px; /* Altura del botón */
    left: 3px; /* Posición inicial a la izquierda */
    background-color: #ffffff; /* Color blanco para el botón */
    border-radius: 22px; /* Bordes redondeados del botón */
    transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55); /* Animación de rebote */
    box-shadow: 0 2px 5px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05); /* Sombra para el botón */
}

/* Estilos para los textos dentro del switch */
.toggle-switch-text-off,
.toggle-switch-text-on {
    position: absolute;
    font-size: 0.95em;
    font-weight: 600;
    color: #000; /* Color de texto predeterminado */
    transition: color 0.3s ease;
    padding: 0 15px; /* Espaciado para el texto dentro del carril */
    width: 50%; /* Cada texto ocupa la mitad del ancho del carril */
    text-align: center;
    box-sizing: border-box; /* Incluir padding en el ancho */
    z-index: 1; /* Para que el texto esté sobre el slider al inicio */
}

.toggle-switch-text-off {
    left: 0;
    color: #000; /* Más oscuro cuando es la opción activa al inicio */
}

.toggle-switch-text-on {
    right: 0;
    color: #000; /* Más claro cuando no es la opción activa al inicio */
}

/* Cuando el input está marcado (switch "on") */
.toggle-switch-input:checked + .toggle-switch-label {
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1), 0 1px 0 rgba(255,255,255,0.7);
}

.toggle-switch-input:checked + .toggle-switch-label .toggle-switch-slider {
    transform: translateX(97px); /* Mueve el slider hacia la derecha (Ancho del label - ancho del slider - 2*left/right padding aprox) */
}

.toggle-switch-input:checked + .toggle-switch-label .toggle-switch-text-off {
    color: #000; /* Texto "Inactivo" se vuelve claro */
}

.toggle-switch-input:checked + .toggle-switch-label .toggle-switch-text-on {
    color: #000; /* Texto "Activo" se vuelve blanco */
}

</style>
